import React, { createContext, useContext, useState } from 'react';

type GetHelpContextType = {
	helpActive: boolean;
	toggleHelp: () => void;
};

const HelpContext = createContext<GetHelpContextType | undefined>(undefined);

export const HelpProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [helpActive, setHelpActive] = useState(false);
	const toggleHelp = React.useCallback(() => setHelpActive(!helpActive), [setHelpActive, helpActive]);

	return (<HelpContext.Provider value={{ helpActive, toggleHelp }}>
		{children}
	</HelpContext.Provider>
	);
};

export const useHelp = (): GetHelpContextType => {
	const context = useContext(HelpContext);

	if (!context) {
		throw new Error('useHelp must be used within a HelpProvider');
	}

	return context;
};